module.exports = __webpack_public_path__ + "media/djx.e7dab56e.mp4";